const standImage = require('../assets/iv-stand/iv-stand-0-stand.png');
const bagConnectImage = require('../assets/iv-stand/iv-stand-2-bag-connect.png');
const bagImage = require('../assets/iv-stand/iv-stand-1-bag.png');
const dripSetImage = require('../assets/iv-stand/iv-stand-3-drip.png');
const dripConnectImage = require('../assets/iv-stand/iv-stand-4-drip-connect.png');
const pumpControlsImage = require('../assets/iv-stand/iv-stand-5-pad.png');
const pumpColumnImage = require('../assets/iv-stand/iv-stand-6-pump.png');
const pumpConnectImage = require('../assets/iv-stand/iv-stand-7-pump-connect.png');

const ivStandImages = {
  stand: {
    image: standImage,
    styles: {
      left: '200px',
      top: '-500px',
      width: '163px',
      zIndex: 0,
      transform: 'scale(.4)'
    }
  },
  bagConnect: {
    image: bagConnectImage,
    styles: {
      left: '289px',
      top: '34px',
      width: 'auto',
      zIndex: 1,
      transform: 'scale(.4)'
    }
  },
  bag: {
    image: bagImage,
    styles: {
      left: '243px',
      top: '-1px',
      width: 'auto',
      zIndex: 1,
      transform: 'scale(.4)',
    }
  },
  badge: {
    styles: {
      left: '300px',
      top: '-40px',
      zIndex: 1,
    }
  },
  dripSet: {
    image: dripSetImage,
    styles: {
      left: '283px',
      top: '38px',
      zIndex: 1,
      transform: 'scale(0.4)',
    }
  },
  dripConnect: {
    image: dripConnectImage,
    styles: {
      left: '289px',
      top: '39px',
      zIndex: 1,
      transform: 'scale(0.4)',
    }
  },
  pumpControls: {
    image: pumpControlsImage,
    styles: {
      left: '238px',
      top: '75px',
      zIndex: 1,
      transform: 'scale(0.4)',
    }
  },
  pumpColumn: {
    image: pumpColumnImage,
    styles: {
      left: '279.4px',
      top: '75.4px',
      zIndex: 1,
      transform: 'scale(0.4)',
    }
  },
  pumpConnect: {
    image: pumpConnectImage,
    styles: {
      left: '267px',
      top: '102px',
      zIndex: 1,
      transform: 'scale(0.4)',
    }
  },
}

export default ivStandImages;